module.exports = __webpack_public_path__ + "static/blog80-3b486d7eb930ecc2a573beb36e2f5124.png";